module.exports = __webpack_public_path__ + "static/media/1.7b684e98.jpg";